import { defineStyleConfig } from '@chakra-ui/react'

export default defineStyleConfig({
  variants: {
    pageFallback: {
      w: '10em',
      h: '10em',
    },
  },
})
